import { DASHBOARD_ARTIFACTS_FIELD_LOADER } from "./dashboard_artifacts_field_loader";
import { DASHBOARD_CONNECTIONS_FIELD_LOADER } from "./dashboard_connections_field_loader";
import { DASHBOARD_PROJECTS_FIELD_LOADER } from "./dashboard_projects_field_loader";

export const DASHBOARD_RUN_FORM_LOADER = async () => {
  const LOADERS = [
    DASHBOARD_CONNECTIONS_FIELD_LOADER,
    DASHBOARD_ARTIFACTS_FIELD_LOADER,
    DASHBOARD_PROJECTS_FIELD_LOADER,
  ];

  await Promise.all(LOADERS.map((loader) => loader()));
};
